/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@emotion/react';
import { SmartLinkSize } from '../../../../../../constants';
import { getIconSizeStyles } from '../../../utils';
const getIconWidth = size => {
  switch (size) {
    case SmartLinkSize.XLarge:
    case SmartLinkSize.Large:
      return '1.5rem';
    case SmartLinkSize.Medium:
    case SmartLinkSize.Small:
    default:
      return '1rem';
  }
};
const getIconStyles = isDisabled => css({
  color: isDisabled ? "var(--ds-text-disabled, #6B778C)" : "var(--ds-icon, #44546F)"
});
const stackItemIconSizeStyles = getIconSizeStyles('20px');
const stackItemIconStyles = css(stackItemIconSizeStyles, {
  display: 'inline-block',
  lineHeight: 0,
  padding: "var(--ds-space-025, 2px)",
  'span,svg,img': {
    lineHeight: 0
  }
});
const ActionIcon = ({
  size,
  testId,
  icon,
  isDisabled,
  asStackItemIcon
}) => jsx("span", {
  css: [getIconStyles(isDisabled), asStackItemIcon ? stackItemIconStyles : getIconSizeStyles(getIconWidth(size))],
  "data-testid": `${testId}-icon`
}, icon);
export default ActionIcon;